import axios, { AxiosResponse, InternalAxiosRequestConfig } from 'axios'
import { ReactNode, useEffect } from 'react'
import { environment } from '../environment'

const axiosInstance = axios.create({
  baseURL: `${environment.gicMarketplaceWsBaseUrl}`,
})

declare global {
  interface Window {
    sidenav: {
      isAuthenticationComplete: boolean
      getAccessTokenSilentlyOrLogout: () => Promise<string>
    }
  }
}

interface AxiosInterceptorProps {
  children: ReactNode
  onInterceptorReady: () => void
}

const AxiosInterceptor = ({
  children,
  onInterceptorReady,
}: AxiosInterceptorProps) => {
  useEffect(() => {
    const reqInterceptor = async (
      config: InternalAxiosRequestConfig
    ): Promise<InternalAxiosRequestConfig> => {
      // Skip token authentication in test mode
      if (environment.test) {
        return config
      }

      try {
        const token = await window.sidenav.getAccessTokenSilentlyOrLogout()
        if (token) {
          // Use the set method on the AxiosHeaders object
          config.headers.set('Authorization', `Bearer ${token}`)
        }
        return config
      } catch (e: unknown) {
        console.error('Failed to fetch token from sidebar')
        throw e
      }
    }

    const interceptor = axiosInstance.interceptors.request.use(reqInterceptor)
    onInterceptorReady()
    return () => axiosInstance.interceptors.response.eject(interceptor)
  })

  useEffect(() => {
    const resInterceptor = (response: AxiosResponse): AxiosResponse => {
      return response
    }

    const interceptor = axiosInstance.interceptors.response.use(resInterceptor)

    return () => axiosInstance.interceptors.response.eject(interceptor)
  }, [])

  return <>{children}</>
}

export default axiosInstance
export { AxiosInterceptor }
